<template>
  <div class="selectteamscompetitions" id="selectteamscompetitions" :key="componentKey">
    <div class="input-container">
      <div class="input-header">
        {{ $t('create_betgame.select_competitions') }}
      </div>
      <div class="input-infotext">
        {{ $t('create_betgame.select_competitions_description') }}
      </div>
      <div v-for="competition in this.selectedCompetitionsMethods(this.$store.state.createBetgame.selectedTeamsCompetitions)" :id="'c'+competition.bg_competition.id" :name="'c'+competition.bg_competition.id" class="input-checkbox"
           v-on:click="competitionChanged($event, competition.bg_competition)">
        <input type="checkbox" :checked="selectedCompetitions[competition.bg_competition.id]" />
        <label :for="competition.bg_competition.id">
          <span>{{ competition.bg_competition.name }}</span>
          <br>
          <span class="input-infotext">{{ getTeams(competition.bg_competition.id) }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'SelectTeamsCompetitions',
  components: {},
  props: {
  },
  data () {
    return {
      selectedCompetitions: this.$store.state.createBetgame.selectedCompetitions,
      componentKey: 0
    }
  },
  beforeCreate () {
    Vue.$log.debug('SelectTeamsCompetitions.beforeCreate ' + this.selectedCompetitions)
  },
  created () {
    Vue.$log.debug('SelectTeamsCompetitions.created ' + this.selectedCompetitions)
  },
  mounted () {
    Vue.$log.debug('SelectTeamsCompetitions.mounted ' + this.selectedCompetitions)
    if(this.$store.state.createBetgame.selectedCompetitions) {
      this.selectedCompetitions = this.$store.state.createBetgame.selectedCompetitions
      this.$store.dispatch('setSelectedCompetitions', this.selectedCompetitions ).then(() => {
      })
    } else {
      this.selectedCompetitions = {}
      this.$store.dispatch('setSelectedCompetitions', this.selectedCompetitions ).then(() => {
      })
    }
  },
  computed: {
    selectableCompetitions() {
      const competitions = this.$store.state.createBetgame.selectedTeamsCompetitions
      var temp = []
      var ids = []
      Vue.$log.debug('SelectTeamsCompetitions.selectableCompetitions ' + JSON.stringify(competitions))
      for (const competition of competitions) {
        Vue.$log.debug('SelectTeamsCompetitions.selectableCompetitions ' + JSON.stringify(competition))
        if(!ids.includes(competition.bg_competition.id)) {
          ids.push(competition.bg_competition.id)
          temp.push(competition)
        }
      }
      const r = temp.sort((a, b) => a.bg_competition.id - b.bg_competition.id)
      this.componentKey += 1
      return r
    },
  },
  methods: {
    selectedCompetitionsMethods(competitions) {
      var temp = []
      var ids = []
      Vue.$log.debug('SelectTeamsCompetitions methods selectableCompetitions ' + JSON.stringify(competitions))
      for (const competition of competitions) {
        Vue.$log.debug('SelectTeamsCompetitions methods selectableCompetitions ' + JSON.stringify(competition))
        if(!ids.includes(competition.bg_competition.id)) {
          ids.push(competition.bg_competition.id)
          temp.push(competition)
        }
      }
      const r = temp.sort((a, b) => a.bg_competition.id - b.bg_competition.id)
      this.componentKey += 1
      return r
    },
    getTeams (competition) {
      var teams = ''
      for (const t of this.$store.state.createBetgame.selectedTeamsCompetitions) {
        if (t.bg_competition.id === competition) {
          teams += t.bg_team.name + ' - '
        }
      }
      if(teams.length === 0) {
        return ''
      }
      return teams.substring(0, teams.length - 3)
      
    },
    competitionChanged(event, competition) {
      Vue.$log.debug('competitionChanged ' + event.target.checked + ' - ' + JSON.stringify(competition))
      if(this.selectedCompetitions[competition.id]) {
        const t = this.selectedCompetitions[competition.id]
        Vue.set(this.selectedCompetitions, competition.id, !t)
      } else {
        Vue.set(this.selectedCompetitions, competition.id, true)
      }
      this.$store.dispatch('setSelectedCompetitions', this.selectedCompetitions).then(() => {
        this.componentKey += 1
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.selectteamscompetitions {
  max-width: 400px;
  margin: 16px auto 16px;
}

</style>

